<!-- partial -->
<div class="modal-body d-flex flex-column pt-0 h-0">
  <div class="d-flex flex-column flex-grow-1 h-0">
    <!-- Spinner for lazyload modules -->
    @if (isLoading) {
      <div class="spinner-wrapper">
        <div class="spinner">Loading...</div>
      </div>
    }

    @if (!isLoading) {
      <div
        class="d-flex flex-column flex-grow-1 h-0"
        contentAnimate
        >
        <!-- <ideapa-breadcrumb></ideapa-breadcrumb> -->
        <router-outlet></router-outlet>
      </div>
    }
  </div>
</div>
